/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateBillOfMaterialsPdfMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  filterStatus?: Types.InputMaybe<Array<Types.BillOfMaterialsItemStatus>>;
  filterType?: Types.InputMaybe<Array<Types.BillOfMaterialsItemType>>;
  aggregateProducts: Types.Scalars['Boolean']['input'];
  filterQuoteId?: Types.InputMaybe<Array<Types.Scalars['ID']['input']>>;
  filterQuoteItemStatus?: Types.InputMaybe<Types.BillOfMaterialsQuoteItemStatusFilter>;
  filterSearchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sections?: Types.InputMaybe<Array<Types.BillOfMaterialsSection>>;
  fields?: Types.InputMaybe<Array<Types.BillOfMaterialsField>>;
}>;


export type GenerateBillOfMaterialsPdfMutation = { billOfMaterialsGeneratePdf: { __typename: 'BillOfMaterialsGeneratePdfResult', url: string } };


export const GenerateBillOfMaterialsPdfDocument = gql`
    mutation GenerateBillOfMaterialsPdf($projectId: ID!, $filterStatus: [BillOfMaterialsItemStatus!], $filterType: [BillOfMaterialsItemType!], $aggregateProducts: Boolean!, $filterQuoteId: [ID!], $filterQuoteItemStatus: BillOfMaterialsQuoteItemStatusFilter, $filterSearchTerm: String, $sections: [BillOfMaterialsSection!], $fields: [BillOfMaterialsField!]) {
  billOfMaterialsGeneratePdf(
    projectId: $projectId
    itemStatus: $filterStatus
    itemType: $filterType
    aggregateProducts: $aggregateProducts
    quoteId: $filterQuoteId
    quoteItemStatus: $filterQuoteItemStatus
    filterSearchTerm: $filterSearchTerm
    sections: $sections
    fields: $fields
  ) {
    url
  }
}
    `;
export type GenerateBillOfMaterialsPdfMutationFn = Apollo.MutationFunction<GenerateBillOfMaterialsPdfMutation, GenerateBillOfMaterialsPdfMutationVariables>;

/**
 * __useGenerateBillOfMaterialsPdfMutation__
 *
 * To run a mutation, you first call `useGenerateBillOfMaterialsPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBillOfMaterialsPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBillOfMaterialsPdfMutation, { data, loading, error }] = useGenerateBillOfMaterialsPdfMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filterStatus: // value for 'filterStatus'
 *      filterType: // value for 'filterType'
 *      aggregateProducts: // value for 'aggregateProducts'
 *      filterQuoteId: // value for 'filterQuoteId'
 *      filterQuoteItemStatus: // value for 'filterQuoteItemStatus'
 *      filterSearchTerm: // value for 'filterSearchTerm'
 *      sections: // value for 'sections'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useGenerateBillOfMaterialsPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBillOfMaterialsPdfMutation, GenerateBillOfMaterialsPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBillOfMaterialsPdfMutation, GenerateBillOfMaterialsPdfMutationVariables>(GenerateBillOfMaterialsPdfDocument, options);
      }
export type GenerateBillOfMaterialsPdfMutationHookResult = ReturnType<typeof useGenerateBillOfMaterialsPdfMutation>;
export type GenerateBillOfMaterialsPdfMutationResult = Apollo.MutationResult<GenerateBillOfMaterialsPdfMutation>;
export type GenerateBillOfMaterialsPdfMutationOptions = Apollo.BaseMutationOptions<GenerateBillOfMaterialsPdfMutation, GenerateBillOfMaterialsPdfMutationVariables>;